var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text",attrs:{"color":"teal","type":"button"},on:{"click":_vm.exportFile}},[_c('v-icon',[_vm._v("mdi-file-excel-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }